import React from "react";
import { Skeleton as AntdSkeleton } from "antd";
import type { SkeletonProps as AntdSkeletonProps } from "antd";

export type SkeletonProps = AntdSkeletonProps;

/**
 * Skeleton component - loading placeholder
 * Re-export Ant Design Skeleton to preserve subcomponents like Skeleton.Input
 */
const Skeleton: React.FC<SkeletonProps> & typeof AntdSkeleton = Object.assign(
  (props: SkeletonProps) => <AntdSkeleton {...props} />,
  AntdSkeleton
);

export default Skeleton;
